<template>
  <Transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    :css="false"
    :appear="true"
  >
    <slot/>
  </Transition>
</template>

<script setup>
  import gsap from 'gsap';

  const props = defineProps({
    hideLeaveDuration: {
      type: Boolean,
      required: false,
      default: false,
    },
  });

  function beforeEnter(el) {
    const target = el.firstElementChild.firstElementChild;

    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
  }

  function enter(el, done) {
    const target = el.firstElementChild.firstElementChild;
    gsap.fromTo(target, { height: 0, paddingTop: 0, paddingBottom: 0 }, {
      duration: 0.3,
      height: `${target.scrollHeight}px`,
      paddingTop: target.style.paddingTop,
      paddingBottom: target.style.paddingBottom,
      onComplete() {
        done();
      },
    });
  }

  function afterEnter(el) {
    const target = el.firstElementChild.firstElementChild;
    target.style.height = '';
  }

  function beforeLeave(el) {
    const target = el.firstElementChild.firstElementChild;
    target.style.overflow = 'hidden';
  }

  function leave(el, done) {
    const target = el.firstElementChild.firstElementChild;

    gsap.to(target, {
      duration: props.hideLeaveDuration ? 0 : 0.2,
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      onComplete() {
        done();
      },
    });
  }
</script>

